<template>
  <div class="property_wrap">
    <div class="pro_top">文本设置</div>
    <div class="pro_con">
<!--      name：主标题，title：副标题 body：内容-->
      <el-form ref="form" label-width="80px">
        <el-form-item label="内容:">
          <el-input type="textarea" v-model="property.body"></el-input>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
  export default {
    props: ["property"],
    data() {
      return {
        dialogImageUrl: '',
        dialogVisible: false,
        form: {}
      };
    },
    watch: {
      property: {
        immediate: true,
        handler(val) {
          this.form = val
        }
      }
    },
    mounted() {
      this.$emit('update:property', this.form)
    },
    methods: {
    }
  };
</script>

